import {
  NoCompanyWrapper,
  SearchAndAddHoldingWrapper,
  SearchFieldWrapper,
} from './styled';
import loadable from '@loadable/component';

const BasicSearch = loadable(
  () => import('@/components/Search/components/BasicSearch')
);

interface Props {
  onSelect?: (company: string) => void;
}

const NoCompany = ({ onSelect }: Props) => {
  return (
    <NoCompanyWrapper>
      <SearchAndAddHoldingWrapper>
        <p>Search for a company to compare.</p>
        <SearchFieldWrapper>
          <BasicSearch onClick={onSelect} />
        </SearchFieldWrapper>
      </SearchAndAddHoldingWrapper>
    </NoCompanyWrapper>
  );
};

export default NoCompany;
